import { Bar, Line } from 'react-chartjs-2';
import {
  Chart as ChartJS, BarElement, CategoryScale, LinearScale,
  LineElement, PointElement, Tooltip, Legend, Title,
} from 'chart.js';
import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { api } from '@/services/api';
import { isDarkMode } from '@/shared/theme';

ChartJS.register(BarElement, CategoryScale, LinearScale, LineElement, PointElement, Tooltip, Legend, Title);

function useThemeTick(): number {
  const [tick, setTick] = useState(0);
  useEffect(() => {
    const h = () => setTick(t => t + 1);
    window.addEventListener('vvf-theme-change', h);
    return () => window.removeEventListener('vvf-theme-change', h);
  }, []);
  return tick;
}

function chartOptions() {
  const dark = isDarkMode();
  const grid = dark ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.08)';
  const text = dark ? '#e0e0e0' : '#333';
  return {
    responsive: true,
    plugins: { legend: { labels: { color: text } } },
    scales: {
      x: { grid: { color: grid }, ticks: { color: text } },
      y: { grid: { color: grid }, ticks: { color: text } },
    },
  };
}

export function MonthlyChart({ year }: { year: number }): React.JSX.Element {
  const tick = useThemeTick();
  const { data } = useQuery({
    queryKey: ['interventions.monthly', year],
    queryFn: async () => (await api.get('/interventions/stats/monthly', { params: { year } })).data,
  });
  const labels = ['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic'];
  const counts = (data ?? []).map((d: { count: number }) => d.count);
  return (
    <div className="card">
      <h3>Interventi {year} per mese</h3>
      <Bar key={tick} options={chartOptions()} data={{
        labels,
        datasets: [{ label: 'Interventi', data: counts, backgroundColor: '#e74c3c', borderRadius: 6 }],
      }} />
    </div>
  );
}

export function YearlyChart(): React.JSX.Element {
  const tick = useThemeTick();
  const { data } = useQuery({
    queryKey: ['interventions.yearly'],
    queryFn: async () => (await api.get('/interventions/stats/yearly')).data,
  });
  const labels = (data ?? []).map((d: { year: number }) => d.year.toString());
  const counts = (data ?? []).map((d: { count: number }) => d.count);
  return (
    <div className="card">
      <h3>Storico annuale</h3>
      <Line key={tick} options={chartOptions()} data={{
        labels,
        datasets: [{
          label: 'Interventi', data: counts,
          borderColor: '#3498db', backgroundColor: 'rgba(52,152,219,0.2)',
          tension: 0.3, fill: true,
        }],
      }} />
    </div>
  );
}
